import React from 'react'
import "./TeamBlockContent.scss"

const TeamBlockContent = ({icon, title, content}) => {
  return (
    <div className="teamBlockContent-container">
      <div className="teamBlockContent-icon-container">
        <img src={icon} alt="Icon" className="teamBlockContent-icon" />
      </div>
      <div className="teamBlockContent-text-container pt-10">
        <h4 className="t4 c-dark-blue no-space">{title}</h4>
        <p className="body-16">{content}</p>
      </div>
    </div>
  );
}

export default TeamBlockContent
